module.exports = __webpack_public_path__ + "380c836ba3f3d248865de27994d2c779.pdf";